import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_36a48bf3 from 'nuxt_plugin_head_36a48bf3' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_4f0a63fd from 'nuxt_plugin_plugin0_4f0a63fd' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_4f0ad85c from 'nuxt_plugin_plugin1_4f0ad85c' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_4f0b4cbb from 'nuxt_plugin_plugin2_4f0b4cbb' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_4f0bc11a from 'nuxt_plugin_plugin3_4f0bc11a' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_4f0c3579 from 'nuxt_plugin_plugin4_4f0c3579' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_4f0ca9d8 from 'nuxt_plugin_plugin5_4f0ca9d8' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_4f0d1e37 from 'nuxt_plugin_plugin6_4f0d1e37' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_4f0d9296 from 'nuxt_plugin_plugin7_4f0d9296' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_4f0e06f5 from 'nuxt_plugin_plugin8_4f0e06f5' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_4f0e7b54 from 'nuxt_plugin_plugin9_4f0e7b54' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_db5f8bfc from 'nuxt_plugin_plugin10_db5f8bfc' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_db5ea33e from 'nuxt_plugin_plugin11_db5ea33e' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_db5dba80 from 'nuxt_plugin_plugin12_db5dba80' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_db5cd1c2 from 'nuxt_plugin_plugin13_db5cd1c2' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_db5be904 from 'nuxt_plugin_plugin14_db5be904' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_db5b0046 from 'nuxt_plugin_plugin15_db5b0046' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_db5a1788 from 'nuxt_plugin_plugin16_db5a1788' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_db592eca from 'nuxt_plugin_plugin17_db592eca' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_db58460c from 'nuxt_plugin_plugin18_db58460c' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_db575d4e from 'nuxt_plugin_plugin19_db575d4e' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_db435cfa from 'nuxt_plugin_plugin20_db435cfa' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_db42743c from 'nuxt_plugin_plugin21_db42743c' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_db418b7e from 'nuxt_plugin_plugin22_db418b7e' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_db40a2c0 from 'nuxt_plugin_plugin23_db40a2c0' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_db3fba02 from 'nuxt_plugin_plugin24_db3fba02' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_36a48bf3 === 'function') {
    await nuxt_plugin_head_36a48bf3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_4f0a63fd === 'function') {
    await nuxt_plugin_plugin0_4f0a63fd(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_4f0ad85c === 'function') {
    await nuxt_plugin_plugin1_4f0ad85c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_4f0b4cbb === 'function') {
    await nuxt_plugin_plugin2_4f0b4cbb(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_4f0bc11a === 'function') {
    await nuxt_plugin_plugin3_4f0bc11a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_4f0c3579 === 'function') {
    await nuxt_plugin_plugin4_4f0c3579(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_4f0ca9d8 === 'function') {
    await nuxt_plugin_plugin5_4f0ca9d8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_4f0d1e37 === 'function') {
    await nuxt_plugin_plugin6_4f0d1e37(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_4f0d9296 === 'function') {
    await nuxt_plugin_plugin7_4f0d9296(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_4f0e06f5 === 'function') {
    await nuxt_plugin_plugin8_4f0e06f5(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_4f0e7b54 === 'function') {
    await nuxt_plugin_plugin9_4f0e7b54(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_db5f8bfc === 'function') {
    await nuxt_plugin_plugin10_db5f8bfc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_db5ea33e === 'function') {
    await nuxt_plugin_plugin11_db5ea33e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_db5dba80 === 'function') {
    await nuxt_plugin_plugin12_db5dba80(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_db5cd1c2 === 'function') {
    await nuxt_plugin_plugin13_db5cd1c2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_db5be904 === 'function') {
    await nuxt_plugin_plugin14_db5be904(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_db5b0046 === 'function') {
    await nuxt_plugin_plugin15_db5b0046(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_db5a1788 === 'function') {
    await nuxt_plugin_plugin16_db5a1788(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_db592eca === 'function') {
    await nuxt_plugin_plugin17_db592eca(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_db58460c === 'function') {
    await nuxt_plugin_plugin18_db58460c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_db575d4e === 'function') {
    await nuxt_plugin_plugin19_db575d4e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_db435cfa === 'function') {
    await nuxt_plugin_plugin20_db435cfa(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_db42743c === 'function') {
    await nuxt_plugin_plugin21_db42743c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_db418b7e === 'function') {
    await nuxt_plugin_plugin22_db418b7e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_db40a2c0 === 'function') {
    await nuxt_plugin_plugin23_db40a2c0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_db3fba02 === 'function') {
    await nuxt_plugin_plugin24_db3fba02(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
